import createApp from "./app";
import "./registerServiceWorker";

createApp().then((app) => app.mount("#app"));
